import React, { useContext } from 'react';
import { LocationContext } from '../../../../ContextProviders';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import {
  CDP_COVID_TEST_SECTION,
  CDP_COVID_TEST_ACTIONS,
} from '../../../../../../core/analytics/events';
import { StyledBody } from '../../CSSstyles';

type Props = {
  requirements?: any[];
};

const MultipleRequirementsBulletPoint = ({ requirements }: Props) => {
  const {
    location,
    location: { id, uclId },
  } = useContext(LocationContext);

  const trackCallClinicClick = () => {
    const trackingProperties = {
      action: CDP_COVID_TEST_ACTIONS.CLICK_CALL_CLINIC,
      locationId: id,
      uclId,
    };
    analyticsTrackEvent(CDP_COVID_TEST_SECTION, trackingProperties);
  };

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const hasMultipleRequirements = requirements.length > 1;

  if (hasMultipleRequirements) {
    return (
      <li>
        <StyledBody>
          To learn more about the screening process,{' '}
          <a href={`tel:${location.phone}`} onClick={trackCallClinicClick}>
            call the clinic
          </a>
          .
        </StyledBody>
      </li>
    );
  }

  return null;
};

export default MultipleRequirementsBulletPoint;
